import { IconPointsCdek } from '@/icon/points/Cdek';
import { IconPointsFivepost } from '@/icon/points/Fivepost';
import { IconPointsPochta } from '@/icon/points/Pochta';
import { IconPointsShops } from '@/icon/points/Shops';
import {
  PickupPoint,
  PickupPointIconKey,
  PickupPointTypeOption
} from '@/util/map-point-maps/types';

export const pickupPoints: PickupPoint[] = [
  {
    id: '6514',
    title: '«Авиценна Фарма №5»',
    street: 'Каширское шоссе, 51к3',
    coords: ['55.640462', '37.690713'],
    type: 'pochta',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06',
    dayFrom: '5 октября'
  },
  {
    id: 'shop-uvi-telekanal',
    title: 'Аутлет Телеканала «Ювелирочка»',
    street: 'г. Москва, улица Веткина 2А, стр. 2',
    coords: ['55.7965', '37.6136'],
    type: 'shops',
    cost: 1,
    deliveryDate: 'Сегодня',
    openingHours: ['Ежедневно 10:00 – 20:00'],
    phone: '+7-965-110-00-20'
  },
  {
    id: 'shop-uvi-botanica',
    title: 'UVI Jewellery в ТОЦ «Botanica»',
    street: 'ул. Вильгельма Пика, 11',
    coords: ['55.8469', '37.6386'],
    type: 'shops',
    cost: 1,
    deliveryDate: 'Сегодня',
    openingHours: ['Ежедневно 10:00 – 22:00'],
    phone: '+7-963-627-96-61'
  },
  {
    id: 'shop-uvi-afi-gallery',
    title: 'UVI Jewellery в МФК «Афи Галерея»',
    street: 'г. Москва, площадь Тверская застава, д. 4',
    coords: ['55.7766', '37.5846'],
    type: 'shops',
    cost: 1,
    deliveryDate: 'Сегодня',
    openingHours: ['Ежедневно 10:00 – 22:00'],
    phone: '+7-965-130-00-20'
  },
  {
    id: 'shop-uvi-gagarinsky',
    title: 'UVI Jewellery в ТРЦ «Гагаринский»',
    street: 'г. Москва, ул. Вавилова, д. 3',
    coords: ['55.7087', '37.5886'],
    type: 'shops',
    cost: 1,
    deliveryDate: 'Сегодня',
    openingHours: ['Ежедневно 09:00 – 22:00'],
    phone: '+7-963-627-93-28'
  },
  {
    id: 'shop-jewelry-europe',
    title: 'Магазин «Ювелирочка» в ТРЦ «Европейский»',
    street: 'г. Москва, площадь Киевского вокзала, д. 2',
    coords: ['55.7446', '37.5662'],
    type: 'shops',
    cost: 1,
    deliveryDate: 'Сегодня',
    openingHours: ['Пн–Чт 10:00 – 22:00', 'Пт–Сб 10:00 – 23:00', 'Вс 10:00 – 22:00'],
    phone: '+7-968-768-65-38'
  },
  {
    id: 'shop-jewelry-schelkovsky',
    title: 'Магазин «Ювелирочка» в ТРЦ «Щелковский»',
    street: 'Москва, Щёлковское ш., д. 75',
    coords: ['55.8099', '37.7987'],
    type: 'shops',
    cost: 1,
    deliveryDate: 'Сегодня',
    openingHours: ['Пн–Чт 10:00 – 22:00', 'Пт–Сб 10:00 – 23:00', 'Вс 10:00 – 22:00'],
    phone: '+7-963-627-91-14'
  },
  {
    id: 'shop-uvi-salaris',
    title: 'UVI Jewellery в ТРЦ «Саларис»',
    street: 'Москва, Киевское шоссе 23-й км, д. 1',
    coords: ['55.6216', '37.4246'],
    type: 'shops',
    cost: 1,
    deliveryDate: 'Сегодня',
    openingHours: ['Ежедневно 10:00 – 22:00'],
    phone: '+7-925-356-82-62'
  },
  {
    id: 'shop-uvi-afimall',
    title: 'UVI Jewellery в ТРЦ «Афимолл Сити»',
    street: 'г. Москва, Пресненская наб., д. 2',
    coords: ['55.7498', '37.5393'],
    type: 'shops',
    cost: 1,
    deliveryDate: 'Сегодня',
    openingHours: ['Пн–Чт 10:00 – 22:00', 'Пт–Сб 10:00 – 23:00', 'Вс 10:00 – 22:00'],
    phone: '+7-936-521-40-12'
  },
  {
    id: 'shop-uvi-mega-white-dacha',
    title: 'UVI Jewellery в ТРЦ «МЕГА Белая Дача»',
    street: 'Московская область, г. Котельники, 1-й Покровский проезд, д. 5',
    coords: ['55.6596', '37.8796'],
    type: 'shops',
    cost: 1,
    deliveryDate: 'Сегодня',
    openingHours: ['Пн–Чт 10:00 – 22:00', 'Пт–Вс 10:00 – 23:00'],
    phone: '+7-985-104-42-78'
  },
  {
    id: '6166',
    title: '«Аптека-риэлти»',
    street: 'Сущёвский Вал, 55',
    coords: ['55.793698', '37.61441'],
    type: 'evita',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5162',
    title: '«Аптека-риэлти»',
    street: 'Плещеева, 8',
    coords: ['55.884898', '37.608544'],
    type: 'evita',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '4148',
    title: '«Аптека-риэлти»',
    street: 'Трёхгорный Вал, 24',
    coords: ['55.761872', '37.562676'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5958',
    title: '«Аптека-риэлти»',
    street: 'Большой Купавенский проезд, 4',
    coords: ['55.77472', '37.820385'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '4969',
    title: '«Аптека-риэлти»',
    street: 'Декабристов, 15Б',
    coords: ['55.86495', '37.604026'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '4020',
    title: '«Аптека-риэлти»',
    street: 'Рязанский Проспект, 48',
    coords: ['55.71622', '37.793373'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '6076',
    title: '«Аптека-риэлти»',
    street: '1-я Новокузьминская 11',
    coords: ['55.715789', '37.78783'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5571',
    title: '«Аптека-риэлти»',
    street: 'Хабаровская 15',
    coords: ['55.822493', '37.823358'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '6341',
    title: '«Аптека-риэлти»',
    street: 'Героев Панфиловцев, 7',
    coords: ['55.857144', '37.43207'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '4604',
    title: '«Белый Сад»',
    street: 'Зубовский проезд, 1',
    coords: ['55.736351', '37.588503'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5983',
    title: '«БЬЮТИ БУТИК»',
    street: 'Зубовский проезд, 1',
    coords: ['55.736351', '37.588503'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5967',
    title: '«Вербена-Фарм»',
    street: 'Краснобогатырская 31к2',
    coords: ['55.809869', '37.705419'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '6569',
    title: '«ЕДА-ДА»',
    street: 'Пречистенская набережная, 15с2',
    coords: ['55.738926', '37.605346'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '7122',
    title: '«ИЮЛЬ»',
    street: 'Ореховый бульвар, 47/33',
    coords: ['55.614587', '37.746517'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '6974',
    title: '«ЛАВАНДА»',
    street: 'Бутырский Вал, 32',
    coords: ['55.783939', '37.587371'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5186',
    title: '«ЛЭШБАР»',
    street: 'Петровский бульвар, 23',
    coords: ['55.76763', '37.620285'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5538',
    title: '«ЛЭШБАР»',
    street: 'Пресненская набережная, 8с1',
    coords: ['55.747115', '37.539078'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '3991',
    title: '«Наша Аптека»',
    street: 'Снежная 17к1',
    coords: ['55.853041', '37.647603'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '4650',
    title: '«НОВА ВИТА ЛЕНИНСКИЙ Проспект»',
    street: 'Ленинский Проспект, 87',
    coords: ['55.679346', '37.533742'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5136',
    title: '«Октябрь»',
    street: 'Покрышкина, 7к1с1',
    coords: ['55.664604', '37.468192'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '4890',
    title: '«САД КРАСОТЫ»',
    street: 'Зубовский проезд, 1',
    coords: ['55.736351', '37.588503'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5989',
    title: '«СИТИ»',
    street: 'Жебрунова, 4',
    coords: ['55.784997', '37.678424'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '4953',
    title: '«Унифарма»',
    street: 'Донецкая 10к1',
    coords: ['55.650891', '37.716171'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5001',
    title: '«ФАРМА-М»',
    street: 'Дмитровское шоссе, 89',
    coords: ['55.863833', '37.545581'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '6236',
    title: '«Эридан»',
    street: 'Кронштадтский бульвар, 47',
    coords: ['55.851717', '37.511724'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5926',
    title: '«Юридическая фирма «АПОЛОГЕТ»',
    street: 'Аптекарский переулок, 13-15',
    coords: ['55.768638', '37.677634'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '4768',
    title: '«Юридическая фирма «АПОЛОГЕТ»',
    street: 'Аптекарский переулок, 13-15',
    coords: ['55.768638', '37.677634'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '5182',
    title: 'H2О-фарм',
    street: 'Маршала Василевского, 17',
    coords: ['55.808923', '37.462317'],
    type: 'cdek',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  },
  {
    id: '8337',
    title: 'iBEAUTY',
    street: 'Тверская, 6с1',
    coords: ['55.7602907', '37.6114099'],
    type: 'fivepost',
    cost: 300,
    deliveryDate: '7 октября, понедельник',
    openingHours: ['Пн-Пт – с 10:00 до 21:00', 'Сб-Вс – с 11:00 до 20:00'],
    phone: '+7 (992) 185-51-06'
  }
];

export const pickupPointTypes: PickupPointTypeOption[] = [
  {
    label: '5Post',
    value: 'fivepost',
    icon: 'fivepost'
  },
  {
    label: 'СДЭК ПВЗ',
    value: 'cdek',
    icon: 'cdek'
  },
  {
    label: 'Почта России ПВЗ',
    value: 'pochta',
    icon: 'pochta'
  },
  {
    label: 'Магазины',
    value: 'shops',
    icon: 'shops'
  }
];

export const iconPickupPointTypes: Record<
  PickupPointIconKey,
  React.FC<{ width?: number; height?: number }>
> = {
  fivepost: IconPointsFivepost,
  cdek: IconPointsCdek,
  shops: IconPointsShops,
  pochta: IconPointsPochta
};
